/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../shared/qrequest";
import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import FormInput from "./FormInput";
import Icon from "./Icon";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class SendDocumentsModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            contactList: []
        };
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/group/list', j => {
            if (j.list)
                this.setState({ contactList: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback)
    }

    submit(e, bypass) {
        if (e) e.preventDefault();
        if (!this.props.item.id) {
            this.alert('No ID.')
            return;
        }
        if (!bypass && this.props.onSend) {
            this.props.onSend(() => this.submit(null, true));
            return;
        }
        this.setState({ submitting: true });
        qreq.post('/api/group/send/documents', { ...this.state.info, orderID: this.props.item.id }, j => {
            if (j.errorCode === 0) {
                this.success('Documents have been sent!');
                this.props.onHide();
            }
            else
                this.alert(j.errorMessage);
            this.setState({ submitting: false });
        }, () => {
            this.unkownErrorCallback();
            this.setState({ submitting: false });
        });
    }

    render() {
        return this.wrapModal(<form onSubmit={this.submit}>
            <FormInput model={this.state.info} name="id" label="Send To" type="select" options={this.state.contactList} required />
            <FormInput model={this.state.info} name="message" label="Message (Optional)" type="textarea" rows={5} />
            <div className="d-flex gap-1">
                <button type="submit" className="btn btn-success" disabled={this.state.submitting}><Icon icon="faPaperPlane" /> <L>Send</L></button>
                <button type="button" className="btn btn-secondary" onClick={this.props.onHide} disabled={this.state.submitting}><Icon icon="faCancel" /> <L>Cancel</L></button>
            </div>
            {this.state.submitting ? <Alert className="mt-3"><L>This might take a few seconds. Please wait...</L></Alert> : null}
        </form>, 'Share Documents', 'lg', this.props.show, this.props.onHide);
    }
}

export default withParamsAndNavigate(SendDocumentsModal);